import { TabsLayoutProps } from 'libs/growth-platform-brand-system-v2/src/layouts/Tabs';
import { ValuePropositionCard } from 'libs/growth-platform-brand-system-v2/src/templates/ValuePropositionCard';
import morphism, { createSchema } from 'morphism';
import React from 'react';
import { Image } from 'libs/growth-platform-brand-system-v2/src/components/Image';
import { schemaImage } from '../components/schemaImage';
import { schemaDatoButton } from '../schemaDatoButton';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';

export const schemaTabsValueProposition = createSchema<TabsLayoutProps, any>({
  cards: {
    path: ['cards', 'locale', 'sectionId'],
    fn: ({ cards, locale, sectionId }: any) =>
      cards.map((card: any, i: number) => {
        const listItems: any[] = card.listItems.split('\n');
        const logos = card.logoList?.[0]?.logos.map(
          (logo: any, index: number) => {
            const logoData = morphism(schemaImage, logo);
            return (
              <Image
                key={index}
                {...logoData}
                className={'max-w-[102px]'}
                sizes="102px"
              />
            );
          },
        );

        const subCards = card.cards.map(
          (
            { ctaButton, image, pixelDensity, ...subCard }: any,
            index: number,
          ) => {
            const ctaProps =
              ctaButton?.[0] &&
              morphism(schemaDatoButton, { ...ctaButton[0], locale });

            return {
              as: ctaProps ? ButtonTracking : 'div',
              component: ctaProps ? ctaProps.as : 'div',
              to: ctaProps?.to,
              href: ctaProps?.href,
              index,
              labelTracking: ctaProps && ctaProps?.title,
              section: ctaProps && `${sectionId}_${i}_Tabs`,
              ...subCard,
              image: image && (
                <Image
                  className="h-full w-full object-cover"
                  sizes={[
                    '(max-width: 692px) 320px',
                    '(max-width: 1279px) 417px',
                    '(min-width: 1280px) 310px',
                    '800px',
                  ]}
                  pixelDensity={pixelDensity || 'image'}
                  width={image.width}
                  height={image.height}
                  src={image.url}
                />
              ),
            };
          },
        );

        return {
          tabIcon: card.tabIcon,
          tabTitle: card.tabTitle,
          children: (
            <ValuePropositionCard
              title={card.title}
              listItems={listItems}
              aside={{
                notation: card.asideKeyValue,
                title: card.asideTitle,
                subtitle: card.asideSubtitle,
              }}
              logoList={{ title: card.logoList?.[0]?.title, logos }}
              cards={subCards}
            />
          ),
        };
      }),
  },
  title: 'vpTitle',
  subtitle: 'vpSubtitle',
});
